import workplacesIcon from '../../images/nav-icon/workplaces.png'
import inventoryIcon from '../../images/nav-icon/inventory.png'
import upgradeIcon from '../../images/nav-icon/upgrade.png'
import researchIcon from '../../images/nav-icon/research.png'
// import swapIcon from '../../images/nav-icon/swap.png'



export const navMenu = [
    {
        title: 'Workplaces',
        icon: workplacesIcon,
        url: '/workplace'
    },
    {
        title: 'Inventory',
        icon: inventoryIcon,
        url: '/inventory'
    },
    {
        title: 'Free Mint',
        icon: upgradeIcon,
        url: '/free-mint'
    },
    // {
    //     title: 'Swap',
    //     icon: swapIcon,
    //     url: '/swap'
    // },
    {
        title: 'Craft',
        icon: researchIcon,
        url: '/craft'
    },
]